export enum EntityStatusTypes {
    ACTIVE = "active",
    INACTIVE = "inactive"
}